var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSmartphoneIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.6665 6.66634C2.6665 4.15218 2.6665 2.8951 3.44755 2.11406C4.2286 1.33301 5.48568 1.33301 7.99984 1.33301C10.514 1.33301 11.7711 1.33301 12.5521 2.11406C13.3332 2.8951 13.3332 4.15218 13.3332 6.66634V9.33301C13.3332 11.8472 13.3332 13.1042 12.5521 13.8853C11.7711 14.6663 10.514 14.6663 7.99984 14.6663C5.48568 14.6663 4.2286 14.6663 3.44755 13.8853C2.6665 13.1042 2.6665 11.8472 2.6665 9.33301V6.66634Z",
    stroke: "#2058E7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 12.667H6",
    stroke: "#2058E7",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmartphoneIcon);
export default __webpack_public_path__ + "static/media/SmartphoneIcon.a805b9d590c82d7fc06acb0ab89da8aa.svg";
export { ForwardRef as ReactComponent };